import * as API from "../framework/api";

const INTERCOM_SETTINGS_STORAGE_KEY = "intercomSettings";

/**
 * Initialize Intercom launcher.
 *
 * @param {Object} opts
 * @param {string} opts.selector
 */
export async function init({ selector }) {
  const intercomSettings = getLocalIntercomSettings() || (await fetchAndStoreIntercomSettings());

  intercomSettings.custom_launcher_selector = selector;
  intercomSettings.alignment = "left";
  intercomSettings.hide_default_launcher = true;

  // The Intercom library requires an `APP_ID` variable to be set in the scope.
  const APP_ID = intercomSettings.app_id;

  // prettier-ignore
  (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + APP_ID;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();

  window.Intercom("boot", intercomSettings);

  await pollBooted();

  const event = new CustomEvent("intercom:booted");
  document.dispatchEvent(event);
}

/**
 * Remove Intercom settings from the session storage, effectivingly clearing the
 */
export function clearCache() {
  sessionStorage.removeItem(INTERCOM_SETTINGS_STORAGE_KEY);
}

function getLocalIntercomSettings() {
  const rawSettings = sessionStorage.getItem(INTERCOM_SETTINGS_STORAGE_KEY);
  return rawSettings ? JSON.parse(rawSettings) : null;
}

async function fetchAndStoreIntercomSettings() {
  const intercomSettings = await API.fetchJSON(p`/ajax/intercom`);
  sessionStorage.setItem(INTERCOM_SETTINGS_STORAGE_KEY, JSON.stringify(intercomSettings));
  return intercomSettings;
}

function pollBooted() {
  return new Promise((resolve, reject) => {
    let timeout = setTimeout(() => {
      clearInterval(interval);
      reject(new Error("Intercom did not boot"));
    }, 30000);

    let interval = setInterval(() => {
      if (window.Intercom.booted) {
        clearInterval(interval);
        clearTimeout(timeout);
        resolve();
      }
    }, 100);
  });
}
